export class Size {
	constructor(idSize, description, sizeLetter) {
		this.idSize = idSize;
		this.description = description;
		this.value = sizeLetter;
	}
}
